export default __webpack_public_path__ + "static/media/closet5-after2-1920w.80606bfb.avif";